/* MY FIGHT HOUSE - fiche produit, conversion (CRO).
   Charge en defer depuis sections/main-product.liquid uniquement.

   1. Observateur de variante : le selecteur existant ne publie aucun
      evenement (et le chemin "plus de 250 variantes" remplace le HTML du
      prix). On observe donc .pdp__info et on compare la valeur du champ
      [data-variant-input] : evenement "mfh:variant-change" pour les autres
      modules, sans toucher au selecteur.
   2. Barre d'achat mobile (4.1). */
(function () {
  'use strict';

  var scope = document.querySelector('[data-product-scope]');
  if (!scope || scope.dataset.mfhPdpReady === 'true') return;
  scope.dataset.mfhPdpReady = 'true';

  var info = scope.querySelector('.pdp__info') || scope;
  var variantInput = scope.querySelector('[data-variant-input]');
  var mainBtn = scope.querySelector('[data-add-btn]');
  var listeners = [];
  var queued = false;
  var lastVariant = variantInput ? variantInput.value : '';

  function run() {
    queued = false;
    var current = variantInput ? variantInput.value : '';
    if (current && current !== lastVariant) {
      lastVariant = current;
      document.dispatchEvent(new CustomEvent('mfh:variant-change', { detail: { variantId: current, scope: scope } }));
    }
    listeners.forEach(function (listener) { listener(); });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(run);
  }

  new MutationObserver(schedule).observe(info, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled', 'hidden', 'class', 'aria-busy']
  });
  /* la valeur d'un input change sans mutation DOM */
  scope.addEventListener('click', function () { window.setTimeout(schedule, 0); });

  window.MFHPdp = {
    scope: scope,
    onUpdate: function (listener) { listeners.push(listener); },
    refresh: schedule
  };

  /* ---------- 4.3 disponibilite en boutique ----------
     Seulement si le rendu initial contient une disponibilite : sans
     emplacement avec retrait local active, aucune requete n'est faite. */
  var pickup = scope.querySelector('[data-mfh-pickup]');
  if (pickup && pickup.querySelector('[data-mfh-pickup-content]')) {
    var pickupController = null;
    var pickupRoot = document.body.dataset.root || '/';
    if (pickupRoot.slice(-1) !== '/') pickupRoot += '/';
    document.addEventListener('mfh:variant-change', function (event) {
      var id = event.detail && event.detail.variantId;
      if (!id) return;
      if (pickupController) pickupController.abort();
      pickupController = 'AbortController' in window ? new AbortController() : null;
      fetch(pickupRoot + 'variants/' + encodeURIComponent(id) + '/?section_id=mfh-pickup-availability', {
        signal: pickupController ? pickupController.signal : undefined,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('pickup');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-mfh-pickup-content]');
          pickup.innerHTML = content ? content.outerHTML : '';
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          /* donnee inconnue : on n'affiche pas une disponibilite perimee */
          pickup.innerHTML = '';
        });
    });
  }

  /* ---------- 4.1 barre d'achat mobile ---------- */
  var bar = scope.querySelector('[data-mfh-buybar]');
  if (!bar || !mainBtn) return;

  var root = document.documentElement;
  var mobile = window.matchMedia('(max-width: 900px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var barBtn = bar.querySelector('[data-mfh-buybar-btn]');
  var barLabel = bar.querySelector('[data-mfh-buybar-label]');
  var barPrice = bar.querySelector('[data-mfh-buybar-price]');
  var barCompare = bar.querySelector('[data-mfh-buybar-compare]');
  var barVariant = bar.querySelector('[data-mfh-buybar-variant]');
  var barImage = bar.querySelector('[data-mfh-buybar-image]');
  var mainLabel = mainBtn.querySelector('[data-add-label]') || mainBtn;
  var hasChoice = bar.dataset.hasChoice === 'true';
  var params = new URLSearchParams(window.location.search);
  var chosen = !hasChoice || bar.dataset.requireChoice !== 'true' || params.has('variant') || params.has('option_values');
  var pastButton = false;
  var visible = false;
  var lifted = [];
  var variantImages = null;

  function readVariantImages() {
    if (variantImages) return variantImages;
    variantImages = {};
    var data = scope.querySelector('[data-variants]');
    try {
      JSON.parse(data ? data.textContent : '[]').forEach(function (variant) {
        var image = variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
        if (image) variantImages[String(variant.id)] = image;
      });
    } catch (error) {}
    return variantImages;
  }

  function sizedImage(url) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  function text(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function sync() {
    var now = scope.querySelector('.pdp__price [data-price]');
    var was = scope.querySelector('.pdp__price [data-compare-price]');
    var currency = text(scope.querySelector('.pdp__price .cur'));
    var isSale = !!(was && !was.hidden && text(was));
    barPrice.textContent = (currency ? currency + ' ' : '') + text(now);
    barPrice.classList.toggle('is-sale', isSale);
    barCompare.hidden = !isSale;
    barCompare.textContent = isSale ? text(was) : '';

    var values = Array.prototype.map.call(scope.querySelectorAll('.pdp__optlabel .val'), text).filter(Boolean);
    barVariant.textContent = hasChoice && chosen ? values.join(' · ') : '';
    barVariant.hidden = !barVariant.textContent;

    if (barImage && variantInput) {
      var image = readVariantImages()[String(variantInput.value)];
      if (image) {
        var src = sizedImage(image);
        if (barImage.getAttribute('src') !== src) barImage.setAttribute('src', src);
      }
    }

    if (!chosen) {
      barBtn.dataset.mode = 'choose';
      barBtn.disabled = false;
      barLabel.textContent = bar.dataset.labelChoose;
    } else {
      /* le bouton principal porte deja l'etat exact : Add to bag, Sold out,
         Unavailable, Adding..., Added */
      barBtn.dataset.mode = 'add';
      barBtn.disabled = mainBtn.disabled;
      barLabel.textContent = text(mainLabel);
    }
  }

  function isShown(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function blocked() {
    return root.classList.contains('mfh-cart-confirm-open') ||
      document.body.classList.contains('menu-open') ||
      isShown(document.getElementById('shopify-pc__banner'));
  }

  /* Widgets flottants d'apps (WhatsApp) : on les remonte au-dessus de la
     barre tant qu'elle est visible. Le theme n'en contient aucun. */
  function liftWidgets(height) {
    lifted.forEach(function (el) { el.style.removeProperty('translate'); });
    lifted = [];
    if (!height) return;
    var candidates = document.querySelectorAll('[id*="whatsapp" i], [class*="whatsapp" i]');
    Array.prototype.forEach.call(candidates, function (el) {
      if (bar.contains(el) || scope.querySelector('.pdp__info').contains(el)) return;
      if (window.getComputedStyle(el).position !== 'fixed') return;
      if (el.getBoundingClientRect().bottom < window.innerHeight - height - 4) return;
      el.style.setProperty('translate', '0 -' + height + 'px');
      lifted.push(el);
    });
  }

  function update() {
    var show = mobile.matches && pastButton && !blocked();
    if (show === visible) return;
    visible = show;
    if (show) {
      bar.hidden = false;
      sync();
      void bar.offsetWidth; /* depart de la transition depuis display:none */
    }
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    bar.inert = !show;
    root.classList.toggle('mfh-buybar-on', show);
    var height = show ? bar.offsetHeight : 0;
    if (show) root.style.setProperty('--mfh-buybar-h', height + 'px');
    liftWidgets(height);
  }

  function goToSelector() {
    var option = scope.querySelector('.pdp__opt');
    if (!option) return;
    option.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
    option.classList.add('mfh-attention');
    window.setTimeout(function () { option.classList.remove('mfh-attention'); }, 1800);
    var target = option.querySelector('.swatch:not([disabled])');
    if (target) target.focus({ preventScroll: true });
  }

  barBtn.addEventListener('click', function () {
    if (barBtn.dataset.mode === 'choose') {
      goToSelector();
      return;
    }
    if (mainBtn.disabled) return;
    mainBtn.click();
  });

  scope.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-opt-index] .swatch, [data-option-value-id]');
    if (swatch && !swatch.disabled && !chosen) {
      chosen = true;
      schedule();
    }
  });

  window.MFHPdp.onUpdate(function () { if (visible) sync(); });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(mainBtn);
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }, { passive: true });
  if (mobile.addEventListener) mobile.addEventListener('change', update);
  /* panneau panier et menu mobile posent une classe sur html / body */
  new MutationObserver(update).observe(root, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('mfh:cart-added', function () { window.setTimeout(update, 400); });
  sync();
})();
